<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-button type="primary" v-if="purchaseUpdate2Purchase" :disabled="selectedRowKeysTabItems.length < 1" @click="Application"> 采购验收 </a-button>
			<!-- <a-button type="primary" @click="exp"> 数据导出 </a-button> -->
		</div>
		<div class="content_main_top">
			<a-input v-model="purchaseCodeplan" allowClear class="a_input_self margin_self" placeholder="采购申请单号" @keyup.enter.native="query"/>
			<!-- <a-select show-search allowClear placeholder="采购申请公司" class="margin_self" @change="handlecompanyplan" v-model="companyIdplan" @keyup.enter.native="query"
			 style="width: 160px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in companylist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select>
			<a-tree-select allowClear :treeData="deptTree2" v-model="deptIdplan" :disabled="!companyIdplan" placeholder="采购申请部门" class="margin_self" @keyup.enter.native="query"
			 style="width: 160px" @change="handledeptplan" treeDefaultExpandAll>
			</a-tree-select> -->
			<!-- <a-select show-search allowClear v-model="deptIdplan" :disabled="!companyIdplan" placeholder="采购申请部门" class="margin_self" @keyup.enter.native="query"
			 style="width: 160px" @change="handledeptplan">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
			<a-input v-model="createByplan" allowClear class="a_input_self margin_self" placeholder="采购申请人" @keyup.enter.native="query"/>
			<a-input v-model="nameplan" allowClear class="a_input_self margin_self" placeholder="物品名称" @keyup.enter.native="query"/>
			<a-button type="primary" v-if="purchaseCheckPurchase" @click="query"> 查询 </a-button>
			<a-button type="primary" ghost @click="result"> 重置 </a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :columns="columns" :data-source="data" bordered :pagination="pagination" rowKey="goodsId" :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChange }"
			 @change="handleTableChange" :scroll="{x: 3000, y: scroll_y }">
				<span slot="index" slot-scope="text, record,index">
					{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
				</span>
				<span slot="deptId" slot-scope="text">
					{{ text ? deptMap[text].text : '' }}
				</span>
				<span slot="itemType" slot-scope="text">
					{{ text ?goodsTypeObj[text]:''}}
				</span>
				<span slot="paymentMethod" slot-scope="text">
					{{ text ?payMap[text]:''}}
				</span>
				<span slot="index" slot-scope="text, record,index">
					{{ (pagination.current - 1) * 10 + index + 1 }}
				</span>
			</a-table>
		</div>
		<a-modal v-model="accepvisible" title="采购验收" width="40%" :maskClosable = "false">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="accepOk"> 确定 </a-button>
				<a-button key="back" @click="accepCancel"> 取消 </a-button>
			</template>
			<a-table :data-source="selectedRow" :pagination="false" bordered :scroll="{ y: scroll_y }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">{{ index + 1 }}</template>
				</a-table-column>
				<a-table-column key="name" title="物品名称" data-index="name" />
				<a-table-column key="itemType" title="资产类别" data-index="itemType">
					<template slot-scope="text, record">
						{{ text ?goodsTypeObj[text]:''}}
					</template>
				</a-table-column>
				<a-table-column key="model" title="规格型号" data-index="model" />
				<a-table-column key="amount" title="申购数量" data-index="amount" />
				<a-table-column key="actualAmount" title="采购数量" data-index="actualAmount" />
				<a-table-column key="action" title="操作" data-index="action">
					<template scope="text,record">
						<a @click="deletes(record)">删除</a>
					</template>
				</a-table-column>
			</a-table>
		</a-modal>
	</div>
</template>

<script>
	import {
		selectBizPurchaseCheck,
		updateBizGoodsInfoList2
	} from '@/api/purchase'
	// import {
	// 	get_dept_tree
	// } from '@/api/assetmenag'
	import {
		checkPermission
	} from '@/utils/permissions'
	import {
		getDeptListEnable2
	} from '@/api/system'
	const deptMap = {}
	const columns = [{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			scopedSlots: {
				customRender: 'index',
			},
			width: 70,
			ellipsis: true,
		}, {
			title: '采购申请单号',
			dataIndex: 'purchaseCode',
			key: 'purchaseCode',
			ellipsis: true,
		}, {
			title: '采购申请公司',
			dataIndex: 'companyName',
			key: 'companyName',
			ellipsis: true,
		}, {
			title: '采购申请部门',
			dataIndex: 'deptId',
			key: 'deptId',
			scopedSlots: {
				customRender: 'deptId',
			},
			ellipsis: true,
		},
		{
			title: '采购申请人',
			dataIndex: 'createByName',
			key: 'createByName',
			ellipsis: true,
		},
		{
			title: '资产类别',
			dataIndex: 'itemType',
			key: 'itemType',
			scopedSlots: {
				customRender: 'itemType',
			},
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			ellipsis: true,
		},
		{
			title: '申购数量',
			dataIndex: 'amount',
			key: 'amount',
			ellipsis: true,
		},
		{
			title: '采购数量',
			dataIndex: 'actualAmount',
			key: 'actualAmount',
			ellipsis: true,
		},
		{
			title: '单位',
			dataIndex: 'unit',
			key: 'unit',
			ellipsis: true,
		},
		{
			title: '申请时间',
			dataIndex: 'createTime',
			key: 'createTime',
			ellipsis: true,
		},
		{
			title: '期望交付时间',
			dataIndex: 'expectDate',
			key: 'expectDate',
			ellipsis: true,
		},
		{
			title: '备注',
			dataIndex: 'remark',
			key: 'remark',
			ellipsis: true,
		},
		{
			title: '采购价格',
			dataIndex: 'purchasePrice',
			key: 'purchasePrice',
			ellipsis: true,
		},
		{
			title: '供应商',
			dataIndex: 'supplier',
			key: 'supplier',
			ellipsis: true,
		},
		{
			title: '采购人',
			dataIndex: 'purchaserName',
			key: 'purchaserName',
			ellipsis: true,
		},
		{
			title: '采购时间',
			dataIndex: 'purchaseTime',
			key: 'purchaseTime',
			ellipsis: true,
		},
		{
			title: '支付方式',
			dataIndex: 'paymentMethod',
			key: 'paymentMethod',
			scopedSlots: {
				customRender: 'paymentMethod',
			},
			ellipsis: true,
		},
		{
			title: '到货日期',
			dataIndex: 'arrivalDate',
			key: 'arrivalDate',
			ellipsis: true,
		},
	]
	export default {
		data() {
			return {
				columns,
				deptMap,
				data: '',
				deptTree: [],
				// deptTree2: [],
				createByplan: undefined,
				purchaseCodeplan: undefined,
				// companyIdplan: undefined,
				// deptIdplan: undefined,
				nameplan: undefined,
				scroll_y: 150,
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				accepvisible: false,
				selectedRowKeysTab: [],
				selectedRowKeysTabItems: [],
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 8,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				purchaseCheckPurchase: checkPermission('purchase:list:check'),
				purchaseUpdate2Purchase: checkPermission('purchase:list:update2'),
				
			};
		},
		created() {
			// get_dept_tree().then((res) => {
			// 	this.companylist = res.data.dept_lis
			// 	this.companylist.unshift({
			// 		dept_id: 0,
			// 		dept_name: '所有公司',
			// 		child_lis: [],
			// 	})
			// })
			getDeptListEnable2().then((res) => {
				const data = res.rows
				if (data.length > 0) {
					const min = Math.min(...data.map((m) => m.parentId))
					this.buildtree2(data, this.deptTree, min)
					this.deptTree.map((d) => {
						if (d.hasOwnProperty('children')) {
							d.children.map((b) => {
								deptMap[b.key] = {
									text: b.title,
								}
								deptMap[d.key] = {
									text: d.title,
								}
							})
						} else {
							deptMap[d.key] = {
								text: d.title,
							}
						}
					})
					this.expandedKeys = data.map((m) => m.parentId)
					this.dataList = data.map((m) => {
						return {
							key: m.deptId,
							title: m.deptName,
						}
					})
				}
			})
			this.get_list()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				console.log(max_h, 'sssssssss')
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height()-120
				}, 1000)
			})
		},
		methods: {
			// handledeptplan(value) {
			// 	this.deptIdplan = value
			// },
			// handlecompanyplan(value) {
			// 	this.deptTree2=[]
			// 	this.deptlist = []
			// 	this.deptIdplan = undefined
			// 	this.$nextTick(() => {
			// 		getDeptListEnable2().then((res) => {
			// 			const data = res.rows
			// 			if (data.length > 0) {
			// 				const min = Math.min(...data.map((m) => m.parentId))
			// 				this.buildtree2(data, this.deptTree2, this.companyIdplan)
			// 			}
			// 		})
			// 	})
			// },
			accepOk() {
				var list = []
				this.selectedRowKeysTabItems.forEach(item => {
					list.push({
						id: item.goodsId,
						isAcceptance: 1
					})
				})
				updateBizGoodsInfoList2(list).then((res) => {
						if (res.code === 200) {
							this.$message.success('验收成功')
							this.$emit('ok')
							this.accepvisible = false
							this.get_list()
						} else {
							this.$message.success(res.msg)
						}
					})
					.catch(() => {
						this.$message.error('系统错误，请稍后再试')
					})
			},
			accepCancel() {
				this.accepvisible = false
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			Application(row) {
				this.selectedRow = this.selectedRowKeysTabItems
				this.accepvisible = true
			},
			deletes(row) {
				var index = this.selectedRowKeysTab.indexOf(row.goodsId)
				this.selectedRowKeysTab.splice(index, 1)
				this.selectedRowKeysTabItems.splice(index, 1)
			},
			onSelectChange(selectedRowKeys, selectedRows) {
				var arr = JSON.parse(JSON.stringify(selectedRows))
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
				this.selectedRowKeysTab = selectedRowKeys
				var obj = {}
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function(item, next) {
					obj[next.goodsId] ? '' : (obj[next.goodsId] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeysTab.forEach((key, idx) => {
					this.selectedRowKeysTabItems.forEach((item, index) => {
						if (key == item.goodsId) {
							newLis.push(item)
						}
					})
				})
				this.selectedRowKeysTabItems = newLis
			},
			get_list() {
				selectBizPurchaseCheck({
					pageSize: this.pagination.pageSize,
					pageNum: this.pagination.current,
					createBy: this.createByplan,
					purchaseCode: this.purchaseCodeplan,
					// ancestors: this.companyIdplan,
					// deptId: this.deptIdplan,
					name: this.nameplan,
				}).then(res => {
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
					this.data = res.rows
				})
			},
			//搜索
			query() {
				this.pagination.current = 1
				this.get_list()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.get_list()
			},
			result() {
				this.createByplan = undefined
				this.purchaseCodeplan = undefined
				// this.companyIdplan = undefined
				// this.deptIdplan = undefined
				this.nameplan = undefined
			},
		},
	}
</script>

<style scoped lang='less'>
</style>
